import { ICreateMessagePost, IReplyMessagePost } from "@/modules/Messaging/messagingDomain"

import msalApi from "../config/setupMSALAxios"; // your configured Axios instance


export function createNewMessage(newMessage: ICreateMessagePost) {
  return msalApi.post('/api/Campaign/CreateNewMessage', newMessage).then(result => result.data)
}

export function replyMessage(reply: IReplyMessagePost) {
  return msalApi.post('/api/Campaign/ReplyMessage', reply).then(result => result.data)
}

export function getMessages() {
  return msalApi.get('/api/Campaign/GetMessages').then(result => result.data)
}

export function messagesAction(payload) {
  return msalApi.post('/api/Campaign/MessagesAction', payload).then(result => result.data)
}
